import { useAction, useAtom } from "@reatom/npm-react"
import { generatePath } from "react-router-dom"

import { PaginationView } from "modules/PsyCatalog/common"
import { searchRequestResultAtom } from "modules/PsyCatalog/common/models/searchRequest"
import {
    goToNextPage,
    goToPageAndUpdateUrl,
    goToPrevPage,
    paginationAtom,
} from "modules/PsyCatalog/common/models/pagination"
import { getSubRoutes } from "modules/PsyCatalog/common/utils"

export function Pagination() {
    const [searchResults] = useAtom(searchRequestResultAtom)
    const [{ currentPage }] = useAtom(paginationAtom)
    const pagesCount = searchResults.pages_count
    const onNextPage = useAction(goToNextPage)
    const onPrevPage = useAction(goToPrevPage)
    const onPage = useAction(goToPageAndUpdateUrl)
    if (pagesCount <= 1) return null
    const { routes, params } = getSubRoutes(location.pathname)
    const filter = params && "filter" in params ? (params?.filter ?? null) : null

    return (
        <PaginationView
            currentPage={currentPage}
            pagesCount={pagesCount}
            getPageUrl={(i) =>
                generatePath(i > 1 ? routes.withPageNumber : routes.path, {
                    page: i.toString(),
                    filter,
                })
            }
            actionHandler={(action) => {
                switch (action.type) {
                    case "prev":
                        return onPrevPage()
                    case "goto":
                        return onPage(action.index)
                    case "next":
                        return onNextPage()
                    default:
                        return
                }
            }}
        />
    )
}
